/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import DTOLoanHistoryViewModal from './DTOLoanHistoryViewModal';
import LoanHistoryViewModalPresenter from './LoanHistoryViewModalPresenter';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import { leavesService } from '../../../../api/services/leavesService';
import { setAllLeaveApplied } from '../../../../infra/aggregates/myProfile/leavesAggregates/leaveAppliedSlice';
import { setAllLeaveHistory } from '../../../../infra/aggregates/myProfile/leavesAggregates/leaveHistorySlice';
import { useTranslation } from 'react-i18next';
import browserTimeZone from '../../../../api/services/localtime';

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  loanViewModalData: any;
}

const LoanHistoryViewModalController = ({
  isModalOpen,
  closeModal,
  loanViewModalData,
}: ModalInterface) => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state);

  const [leaveTypes, setLeaveTypes] = useState([]);

  const getData = (data: any) => {
    applyLeave(data);
  };

  const getLeaveTypeData = (data: any) => {
    setLeaveTypes(data);
  };

  async function applyLeave(data: any) {
    if (selector) {
      const empID: any = selector.authSlice.emp_id;
      const companyID: any = selector.authSlice.company_id;

      const formData = new FormData();

      formData.append('emp_id', empID);
      formData.append('company_id', companyID);
      formData.append('leave_type_id', data.leaveTypeId);
      formData.append('start_date', data.startDate);
      formData.append('end_date', data.endDate);
      formData.append('day_freq', data.dayFreq);
      formData.append('days', data.days);
      formData.append('leave_reason', data.reason);
      formData.append('attachment', data.file);
      formData.append('timezone', browserTimeZone);

      const response: any = await leavesService.applyLeave(formData);

      if (response.response == 'success') {
        console.log('respsnse data status', response.data);

        dispatch(setAllLeaveApplied(response?.data?.applied_leaves));

        dispatch(setAllLeaveHistory(response?.data?.leaves_history));
      }
    }
  }

  return (
    <>
      <DTOLoanHistoryViewModal setAllLeaveTypesData={getLeaveTypeData} />

      <LoanHistoryViewModalPresenter
        callBackGetData={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        allLeaveTypes={leaveTypes}
        loanViewModalData={loanViewModalData}
        currency={selector.authSlice.currency}
        trans={t}
      />
    </>
  );
};

export default LoanHistoryViewModalController;
